import { render, staticRenderFns } from "./bonusDetail.vue?vue&type=template&id=15f42cbc&scoped=true"
import script from "./bonusDetail.vue?vue&type=script&lang=js"
export * from "./bonusDetail.vue?vue&type=script&lang=js"
import style0 from "./bonusDetail.vue?vue&type=style&index=0&id=15f42cbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f42cbc",
  null
  
)

export default component.exports